import React from "react";
import classNames from "classnames";

import BaseReportTable from "./BaseReportTable";

import "components/reportTable/reportTable.scss";

interface IProps {
  data: Array<Record<string, any>>;
  columns: Array<Record<string, any>>;
  description: string;
  compileDate: string;
}

export default function CustomersCreatedTable(props: IProps) {
  function cellData(_columnId: string, cellValue: string) {
    return cellValue !== null && cellValue !== undefined ? cellValue : "";
  }

  function cellClassNames(cell: any, isRowLocked: boolean) {
    const original = cell.row?.original;
    const isClickableRow = !cell.isGrouped && !cell.isAggregated && !original?.is_footer;

    return classNames({
      "report-table-row-locked": isRowLocked,
      "report-table-cell-clickable": isClickableRow && cell.column.id === "customer" && original?.customer_id,
    });
  }

  function cellOnClick(cell: any) {
    if (!cell || cell.isGrouped || cell.isAggregated) {
      return null;
    }

    const original = cell.row?.original;

    if (cell.column.id === "customer" && original?.customer_id) {
      return window.open(`/admin/customers/${original.customer_id}/profile`);
    }

    return null;
  }

  function footerData(columnId: string, footerRow?: Record<string, any>) {
    if (!footerRow) {
      return null;
    }

    return (footerRow[columnId] as string) ?? null;
  }

  return (
    <BaseReportTable
      data={props.data}
      columns={props.columns}
      description={props.description}
      compileDate={props.compileDate}
      cellOnClick={cellOnClick}
      cellData={cellData}
      cellClassNames={cellClassNames}
      footerData={footerData}
      expanding={false}
    />
  );
}
